import Card from '../../../common/Card';
import React from 'react';
import LanguageItem from './LanguageItem';
import Tabs from '../../../common/Tabs';
import Tab from '../../../common/Tab';
import { useSelector } from 'react-redux';

function LanguageList({ languages, onEdit, onDelete }) {
  const { selectedTab } = useSelector((state) => state.assets);

  return (
    <div className="skill-list">
      <Tabs value={selectedTab} TabIndicatorProps={{ style: { background: 'var(--accent-color)' } }}>
        <Tab label="My Languages" />
      </Tabs>

      <Card>
        <div>
          {languages.length > 0 ? (
            <div className="row row-cols-2 mt-2">
              {languages.map((language) => (
                <div className="col-6" key={language.id}>
                  <LanguageItem language={language} onEdit={() => onEdit(language)} onDelete={() => onDelete(language.id)} />
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-3">
              <p className="text-muted small text-center">No languages added yet. Add your languages to build your CV.</p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}

export default LanguageList;
